import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Heading, Paragraph } from '@digdir/designsystemet-react';

import styled from '../../../../../styled';
import { DetailingStep } from '../../../utils/registerEnums';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
`;

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  categoryToDelete?: DetailingStep;
}

export const DeleteExistingDataDialog: FC<Props> = ({ isOpen, onConfirm, onCancel, categoryToDelete }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onCancel} style={{ borderRadius: 'var(--ds-size-2)' }}>
      <ContentWrapper>
        <Heading>
          {t('register.step.delete.title', {
            stegtittel: t(`register.step.${categoryToDelete}`)
          })}
        </Heading>
        <Paragraph>
          {t('register.step.delete.description', {
            stegtittel: t(`register.step.${categoryToDelete}`)
          })}
        </Paragraph>
        <div style={{ display: 'flex', gap: 'var(--ds-size-2)' }}>
          <Button variant="secondary" onClick={onCancel}>
            {t('cancel')}
          </Button>

          <Button onClick={onConfirm}>{t('confirm')}</Button>
        </div>
      </ContentWrapper>
    </Dialog>
  );
};
